<template>


  <div class="contact">
    <div class="banner">
      <div class="container-width">
        <div class="contact-banner">
          <p class="banner-title">
            联系我们
            <br data-v-38c2a234="">
            Contact us.
          </p>
        </div>
      </div>
    </div>
    <div class="contact-us container-width">
      <div class="loaction-us">
        <div class="contact-city">
          <p data-v-38c2a234="">
            深圳
          </p>
          <p data-v-38c2a234="">
            XIAMEN
          </p>
        </div>
        <p data-v-38c2a234="">
          深圳市雁来信网络科技有限公司
        </p>
        <p data-v-38c2a234="">
          软件园三期C08栋9-11楼
        </p>
        <div class="contact-tel">
          <p data-v-38c2a234="">
            Tel: 4000975976
          </p>
          <p data-v-38c2a234="">
            P.C.: 361000
          </p>
        </div>
      </div>
      <div class="contact-mail">
        <p data-v-38c2a234="">
          品牌及媒介合作
        </p>
        <p data-v-38c2a234="">
          - Email: marketing@taqu.cn
        </p>
        <div class="contact-qd">
          <p data-v-38c2a234="">
            违法与不良信息举报
          </p>
          <p data-v-38c2a234="">
            - Tel: 4000975976
          </p>
        </div>
        <div class="contact-qd">
          <p data-v-38c2a234="">
            侵权协查邮箱
          </p>
          <p data-v-38c2a234="">
            - Email: qinquanxiecha@taqu.cn
          </p>
        </div>
        <div class="contact-qd">
          <p data-v-38c2a234="">
            招聘邮箱
          </p>
          <p data-v-38c2a234="">
            - Email: HR@taqu.cn
          </p>
        </div>
      </div>
      <div class="contact-mail">
        <p data-v-38c2a234="">
          主播招募及公会合作
        </p>
        <p data-v-38c2a234="">
          - Email: zhibo@taqu.cn
        </p>
        <div class="contact-live">
          <p data-v-38c2a234="">
            服务热线服务时段
          </p>
          <p data-v-38c2a234="">
            - 社区工作日: 9:30-12:00 13:30-18:30
          </p>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  export default {
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .container-width {
    width: 1060px;
    margin: 0 auto;
  }

  .contact,.license{
    padding-top:0px
  }
  .banner{
    height:368px;
    background:#ffd321 url(../../assets/img/196_touch_contact_us.aaed3372.jpg) 100% 100% no-repeat
  }
  .contact-banner{
    height:368px;
    padding-top:138px
  }
  .banner-title{
    color:#282121;
    font-family:PingFangSC-Semibold,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",PingFang SC,Heiti SC,SimHei;
    font-size:72px;
    line-height:88px
  }
  .contact-us{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
    padding-top:50px;
    padding-bottom:74px;
    color:#282121;
    font-family:PingFang-SC-Medium,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",PingFang SC,Heiti SC,SimHei;
    font-size:14px;
    line-height:20px
  }
  .loaction-us{
    padding-left:29px;
    background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUdwTCcgICwhIS4pKSchISggICcgICkiIiwiIicgICkiIighISgjIycfHyghISggIFUqKighISgiIikjIzAlJSgiIighISghISghIXTjdmkAAAAYdFJOUwDYLgzE8eK0NPsl9jlBg+kGuFJdF6NkiwEFaDIAAACXSURBVHjahZFJDsMgDAAd9iUJ2cv/X1rhyhT7kjmZGQUiGV7Znt1Ftz+b8IurP9zC/BkrEc/Bz+ipzNCZ6sjU/YFnH3TwOB0UbvQ4YrnZTQHHwO7K7aRx1G3MFIr4olAw4g1D4SP+aqWQKiMmIHYWPHRSHHxO8Gcdwsq2Ybo3wLgK7eMCjrLorQLJkpvHXchiyUuUUfDOFx8sE8PawF7GAAAAAElFTkSuQmCC) 0 2px no-repeat
  }
  .contact-city{
    padding-bottom:10px;
    font-family:PingFang-SC-Heavy,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",PingFang SC,Heiti SC,SimHei;
    font-weight:700;
    line-height:20px
  }
  .contact-tel{
    padding-top:34px
  }
  .contact-mail{
    padding-left:142px;
    line-height:28px
  }
  .contact-live,.contact-qd{
    padding:24px 0
  }
  .contact-qd+.contact-qd{
    padding-top:0
  }
  .license-box{
    padding-bottom:40px
  }
  .license-box img{
    width:100%;
    border:1px solid #979797
  }
  .contact-time-tips{
    padding-left:1em
  }


</style>



// WEBPACK FOOTER //
// src/views/Contact.vue